import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './en';
import esTranslations from './es';
const resources = {
  es: {
    translation: esTranslations,
  },
  en: {
    translation: enTranslations,
  },
};
const getInitialLang = () => {
  const saved = localStorage.getItem('appLang');
  if (saved) return saved;
  const browser = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  return browser.startsWith('es') ? 'es' : 'en';
};
// Mantiene <html lang> en sintonía con el idioma de la app. Si quedan
// desfasados (html dice "en" y el texto está en español), el navegador detecta
// la contradicción y ofrece traducir la página por encima de nuestra i18n.
const sincronizarLangDelDocumento = (lng) => {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.setAttribute('lang', lng);
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLang(),
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
    format: (value, format, lng) => {
      if (format === 'ordinal' && lng === 'en') {
        const s = ['th', 'st', 'nd', 'rd'],
          v = value % 100;
        return value + (s[(v - 20) % 10] || s[v] || s[0]);
      }
      return value;
    },
  },
});

sincronizarLangDelDocumento(i18n.language);
i18n.on('languageChanged', sincronizarLangDelDocumento);

export default i18n;
